import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
/*import { Http, Headers, RequestOptions } from '@angular/http';*/
import 'rxjs/add/operator/map';

import { SmartAudio } from '../providers/smart-audio';

/* User Data are in the variable userdata in this provider */

// ---- COMMON MODULES ---- //
import { Functions } from './functions';

@Injectable()
export class UserdataModel {
    userdata: any=[];

    constructor(private storage: Storage, public functions: Functions, public smartAudio: SmartAudio){
        this.getUserdataStored();
    }

    setUserdata(
        /* --- PROFILE DATA --- */
        guidUser:string,
        username:string,
        email:string,
        password:string,
        fullname:string,
        sex:string,
        education:string,
        birthDate:string,  //"1980-11-04"

        picture:string,
        creationDate:string,
        language:string,
        spokenLanguages:string,
        roles:string,
        lastAccess:string,
        lastLogin:string,
        link:string,
        cancelLink:string,
        
        /* --- GAMEDATA --- */
        score:number,
        level: number,
        numberOfLogin:number,
        collectiblesGot:any,
        booksinfo:any,
        settingsCurrentGamemode:any,
        settingsCurrentLanguage:any,
        settingsCurrentSoundEffectStatus:number,
        settingsCurrentMusicVolume:number,
        settingsCurrentCatChosen:string,

        /* --- SESSION DATA --- */
        token:string,
        session_name:string,
        sessid:string
        ){
        return new Promise((resolve) =>{
            
            if(guidUser!="") {this.userdata[0].guidUser=guidUser;}
            if(username!="") {this.userdata[0].username=username;}
            if(email!="") {this.userdata[0].email=email;}
            if(password!="") {this.userdata[0].password=password;}
            if(fullname!="") {this.userdata[0].fullname=fullname;}
            if(sex!="") {this.userdata[0].sex=sex;}
            if(education!="") {this.userdata[0].education=education;}
            if(birthDate!="") {this.userdata[0].birthDate=birthDate;}

            if(picture!="") {this.userdata[0].picture=picture;}
            if(creationDate!="") {this.userdata[0].creationDate=creationDate;}
            if(language!="") {this.userdata[0].language=language;}
            if(spokenLanguages!="") {this.userdata[0].spokenLanguages=spokenLanguages;}
            if(roles!="") {this.userdata[0].roles=roles;}
            if(lastAccess!="") {this.userdata[0].lastAccess=lastAccess;}
            if(lastLogin!="") {this.userdata[0].lastLogin=lastLogin;}
            if(link!="") {this.userdata[0].link=link;}
            if(cancelLink!="") {this.userdata[0].cancelLink=cancelLink;}

            if(score!=-1) {this.userdata[0].score=score;}

            if(level!=-1) {this.userdata[0].level=level;}
            if(numberOfLogin!=-1) {this.userdata[0].numberOfLogin=numberOfLogin;}
            if(booksinfo!="") {this.userdata[0].booksinfo=booksinfo;}
            if(collectiblesGot!="") {this.userdata[0].collectiblesGot=collectiblesGot;}
            if(settingsCurrentGamemode!="") {this.userdata[0].settingsCurrentGamemode=settingsCurrentGamemode;}
            if(settingsCurrentLanguage!="") {this.userdata[0].settingsCurrentLanguage=settingsCurrentLanguage;}
            if(settingsCurrentSoundEffectStatus!=-1) {this.userdata[0].settingsCurrentSoundEffectStatus=settingsCurrentSoundEffectStatus;}
            if(settingsCurrentMusicVolume!=-1) {this.userdata[0].settingsCurrentMusicVolume=settingsCurrentMusicVolume;}
            if(settingsCurrentCatChosen!="") {this.userdata[0].settingsCurrentCatChosen=settingsCurrentCatChosen;}
           
            if(token!="") {this.userdata[0].token=token;}
            if(session_name!="") {this.userdata[0].session_name=session_name;}
            if(sessid!="") {this.userdata[0].sessid=sessid;}
            
            this.storeUserdata().then((response)=>{
                resolve("UserDataStored");
            });
        });
    }

    isCurrentBookComplete(){
        var idBook=this.functions.getIdCurrentBook();
        return this.isBookComplete(idBook);
    }

    isCurrentBookBeginned(){
        var idBook=this.functions.getIdCurrentBook();
        return this.isBookBeginned(idBook);
    }
    

    isBookComplete(idBook){
        if( this.getBookmarkLetterofBook(idBook)<0
        || (this.getIndexLastCharacterInBookOfBook(idBook)!=0 && this.getBookmarkLetterofBook(idBook)>this.getIndexLastCharacterInBookOfBook(idBook))){
            return true;
        }else{
            return false;
        }
    }

    isBookBeginned(idBook){
        if((this.getBookmarkLetterofBook(idBook)>0)
        && (this.getBookmarkLetterofBook(idBook)<this.getIndexLastCharacterInBookOfBook(idBook))){
            return true;
        }else{
            return false;
        }  
    }

    isBookBeginnedRightNow(idBook){
        if((this.getBookmarkLetterofBook(idBook)==0 && !this.functions.isGameModeShannonReverse())
        || (this.getBookmarkLetterofBook(idBook)>=(this.getIndexLastCharacterInBookOfBook(idBook)-1) && this.functions.isGameModeShannonReverse())){
            return true;
        }else{
            return false;
        }  
    }

    resetUserSettingsToDefaultValues(){
        //console.log("RESET ALL SETTINGS!");

        this.functions.setGamemodeTo(this.functions.emptySettingsCurrentGamemode);
        this.setSettingsCurrentGamemode(this.functions.emptySettingsCurrentGamemode);
        this.functions.setGameMode();
    
        this.functions.changeLanguageTo(this.functions.emptySettingsCurrentLanguage);
        this.setSettingsCurrentLanguage(this.functions.emptySettingsCurrentLanguage);
        this.functions.setLanguage();
    
        this.smartAudio.changeSoundEffectsStatus(this.functions.emptySettingsCurrentSoundEffectStatus);
        this.setSettingsCurrentSoundEffectStatus(this.functions.emptySettingsCurrentSoundEffectStatus);
        this.functions.setSoundEffectIsActive();

        this.smartAudio.volume=this.functions.emptySettingsCurrentMusicVolume;
        this.setSettingsCurrentMusicVolume(this.functions.emptySettingsCurrentMusicVolume);
        this.smartAudio.changeVolumeApp();
        this.functions.setVolume();

        this.functions.catChosen=this.functions.emptySettingsCurrentCatChosen;
        this.setSettingsCurrentCatChosen(this.functions.emptySettingsCurrentCatChosen);
        this.functions.setCatChosen();
    }

    /* --------- GETTER/SETTER --------- */

    setWholeUserdata(userdata){
        this.userdata[0]=userdata;
        this.storeUserdata();
    }

    getWholeUserdata(){
        return this.userdata[0];   
    }

    storeUserdata(){
        return new Promise((resolve) =>{
        this.storage.set('userdata', JSON.stringify(this.userdata)).then((response)=>{
            resolve("UserDataStoredLocally");
          });
        });
    }

    getUserdataStored(){
        this.storage.get('userdata').then((userdata) => {
            if(userdata){
                this.userdata=JSON.parse(userdata);
            }else{
                this.userdata.push({});
            }
        });
    }

    clearUserdata(){
        return new Promise((resolve) =>{
            this.userdata=[];
            this.userdata.push({});
            this.storeUserdata().then((response)=>{
                resolve("storeUserdataOk");
            });
        });
    }

    setGuidUser(guidUser){
        this.userdata[0].guidUser=guidUser;
        this.storeUserdata();
    };

    getGuidUser(){
        return this.userdata[0].guidUser;
    };

    setUsername(username){
        this.userdata[0].username=username;
        this.storeUserdata();
    };

    getUsername(){
        return this.userdata[0].username;
    };

    setEmail(email){
        this.userdata[0].username=email;
        this.storeUserdata();
    };

    getEmail(){
        return this.userdata[0].email;
    };

    setPassword(password){
        this.userdata[0].username=password;
        this.storeUserdata();
    };

    getPassword(){
        return this.userdata[0].password;
    };

    setFullname(fullname){
        this.userdata[0].username=fullname;
        this.storeUserdata();
    };

    getFullname(){
        return this.userdata[0].fullname;
    };

    setSex(sex){
        this.userdata[0].sex=sex;
        this.storeUserdata();
    };

    getSex(){
        return this.userdata[0].sex;
    };

    setEducation(education){
        this.userdata[0].education=education;
        this.storeUserdata();
    };

    getEducation(){
        return this.userdata[0].education;
    };

    setBirthDate(birthDate){
        this.userdata[0].birthDate=birthDate;
        this.storeUserdata();
    };

    getBirthDate(){
        return this.userdata[0].birthDate;
    };

    setLanguage(language){
        this.userdata[0].language=language;
        this.storeUserdata();
    };

    getLanguage(){
        return this.userdata[0].language;
    };

    setScore(score){
        this.userdata[0].score=score;
        this.storeUserdata();
    };

    getScore(){
        return this.userdata[0].score;
    };

    setLevel(level){
        this.userdata[0].level=level;
        this.storeUserdata();
    };

    getLevel(){
        return this.userdata[0].level;
    };

    setNumberOfLogin(numberOfLogin){
        this.userdata[0].numberOfLogin=numberOfLogin;
        this.storeUserdata();
    };

    getNumberOfLogin(){
        return this.userdata[0].numberOfLogin;
    };

    setBooksinfo(booksinfo){
        this.userdata[0].booksinfo=booksinfo;
        this.storeUserdata();
    };

    getBooksinfo(){
        return this.userdata[0].booksinfo;
    };

    setCollectibleGot(idCollectible,quantity,isglobalforanybook){
        // Returns true if the collectibles has been given or false if not (like if the collectible was already there)
        // isglobalforanybook determines if the collectibles must be given one time for each book, or one time for one of any of all the book
        //console.log("isGotCollectible num: "+idCollectible+" quantity: "+quantity+" isglobalforanybook:"+isglobalforanybook+" is: "+this.isGotCollectibleNumForCurrentBook(idCollectible,quantity));
        
        if ( (!this.isGotCollectibleNumForCurrentBook(idCollectible,quantity) && !isglobalforanybook)
        || (!this.isGotCollectibleNumForAnyBook(idCollectible,quantity) && isglobalforanybook)      
        ) {
            //console.log("++++ collectible IS NOT got");
            if (this.functions.isObjectEmpty(this.userdata[0].collectiblesGot)) { 
                this.userdata[0].collectiblesGot=[{
                    idCollectible: idCollectible,
                    idBook:this.functions.getIdCurrentBook(),
                    quantity: quantity
                }];
            }else{
                this.userdata[0].collectiblesGot.push({
                    idCollectible: idCollectible,
                    idBook:this.functions.getIdCurrentBook(),
                    quantity: quantity
                });
            }
            this.storeUserdata();
            return true;
        }else{
            //console.log("++++ collectible IS got");
            return false;
        }
    };

    getCollectiblesGot(){
        return this.userdata[0].collectiblesGot;
    };

    getNumOfCollectiblesGot(){
        if (this.functions.isObjectEmpty(this.userdata[0].collectiblesGot)) {
            return 0;
        }else{
            return this.userdata[0].collectiblesGot.length;
        }
        
    };

    isGotCollectibleNumForAnyBook(idCollectible, quantity){
        var filtered = this.getCollectiblesGot();
        if (!this.functions.isObjectEmpty(filtered)) { 
            filtered = filtered.filter(function (item) {
                return (item.idCollectible == idCollectible && item.quantity == quantity);
            })
            if (this.functions.isObjectEmpty(filtered)) { return false; } else { return true; }
        }else{
            return false;
        }
    }

    isGotCollectibleNumForCurrentBook(idCollectible, quantity){
        var filtered = this.getCollectiblesGot();
        var idCurrentBook = this.functions.getIdCurrentBook();
        if (!this.functions.isObjectEmpty(filtered)) { 
            filtered = filtered.filter(function (item) {
                return (item.idCollectible == idCollectible && item.idBook == idCurrentBook && item.quantity == quantity);
            })
            if (this.functions.isObjectEmpty(filtered)) { return false; } else { return true; }
        }else{
            return false;
        }
    }

    isGotCollectibleNumForBook(idCollectible, idBook, quantity){
        var filtered = this.getCollectiblesGot();
        if (!this.functions.isObjectEmpty(filtered)) {
            filtered = filtered.filter(function (item) {
                return ((item.idCollectible == idCollectible) && (item.idBook == idBook) && (item.quantity == quantity));
            })
        }

        if (this.functions.isObjectEmpty(filtered)) { return false; } else{ return true; }
    }

    // categoryOfGamemodes can be 'versus' or 'classic' or 'all'
    getArrayGamemodes(categoryOfGamemodes){
        switch (categoryOfGamemodes) {
            case 'versus':
                return this.functions.versusGamemodes;
                //break;
            case 'classic':
                return this.functions.classicGamemodes;
                //break;
            case 'all':
                return this.functions.classicGamemodes.concat(this.functions.versusGamemodes);
                //break;
            default:
                break;
        }
    }

    // categoryOfGamemodes can be 'versus' or 'classic' or 'all'
    getNumMaxChunksCompletedInGamemodeCategory(categoryOfGamemodes){
        var numMaxChunkCompleted=Infinity;
        var tmpnumMaxChunkCompleted;
        var gamemodesArray=this.getArrayGamemodes(categoryOfGamemodes);
        
        for (let i = 0; i < gamemodesArray.length; i++) {
            tmpnumMaxChunkCompleted=this.getNumTotalChunksCompletedInGamemode(gamemodesArray[i]);
            if (tmpnumMaxChunkCompleted<numMaxChunkCompleted) {
                numMaxChunkCompleted=tmpnumMaxChunkCompleted;
            }
        }
        return numMaxChunkCompleted;
    }

    // categoryOfGamemodes can be 'versus' or 'classic' or 'all'
    getNumTotalChunksCompletedInGamemodeCategory(categoryOfGamemodes){
        var numTotalChunkCompleted=0;
        var gamemodesArray=this.getArrayGamemodes(categoryOfGamemodes);
        
        for (let i = 0; i < gamemodesArray.length; i++) {
            numTotalChunkCompleted+=this.getNumTotalChunksCompletedInGamemode(gamemodesArray[i]);
        }
        return numTotalChunkCompleted;
    }

    getNumTotalChunksCompletedInGamemode(gamemode){
        var numTotalChunkCompleted=0;
        var booksArray=this.functions.getAllBooksPlayableInAllGamemodes();

        for (let i = 0; i < booksArray.length; i++) {
            if (this.getGamemodeofBook(booksArray[i])==gamemode) {
                numTotalChunkCompleted+=this.getNumchunkcompletedOfBook(booksArray[i]);  
            }      
        }
        return numTotalChunkCompleted;
    }

    // categoryOfGamemodes can be 'versus' or 'classic' or 'all'
    getNumTotalCharsGuessedInGamemodeCategory(categoryOfGamemodes){
        var numTotalCharsGuessed=0;
        var gamemodesArray=this.getArrayGamemodes(categoryOfGamemodes);
        
        for (let i = 0; i < gamemodesArray.length; i++) {
            numTotalCharsGuessed+=this.getNumTotalCharsGuessedInGamemode(gamemodesArray[i]);
        }
        return numTotalCharsGuessed;
    }

    getNumTotalCharsGuessedInGamemode(gamemode){
        var numTotalCharsGuessed=0;
        var booksArray=this.functions.getAllBooksPlayableInAllGamemodes();

        for (let i = 0; i < booksArray.length; i++) {
            if (this.getGamemodeofBook(booksArray[i])==gamemode) {
                numTotalCharsGuessed+=this.getNumcharguessedOfBook(booksArray[i]);  
            }      
        }
        return numTotalCharsGuessed;
    }

    // categoryOfGamemodes can be 'versus' or 'classic' or 'all'
    getNumTotalGamesPlayedInGamemodeCategory(categoryOfGamemodes){
        var numTotalGamesPlayed=0;
        var gamemodesArray=this.getArrayGamemodes(categoryOfGamemodes);
        
        for (let i = 0; i < gamemodesArray.length; i++) {
            numTotalGamesPlayed+=this.getNumTotalGamesPlayedInGamemode(gamemodesArray[i]);
        }
        return numTotalGamesPlayed;
    }

    getNumTotalGamesPlayedInGamemode(gamemode){
        var numTotalGamesPlayed=0;
        var booksArray=this.functions.getAllBooksPlayableInAllGamemodes();

        for (let i = 0; i < booksArray.length; i++) {
            if (this.getGamemodeofBook(booksArray[i])==gamemode) {
                numTotalGamesPlayed+=this.getNumgamesplayedOfBook(booksArray[i]);  
            }      
        }
        return numTotalGamesPlayed;
    }

    // categoryOfGamemodes can be 'versus' or 'classic' or 'all'
    getNumTotalGamesWonInGamemodeCategory(categoryOfGamemodes){
        var numTotalGamesWon=0;
        var gamemodesArray=this.getArrayGamemodes(categoryOfGamemodes);
        
        for (let i = 0; i < gamemodesArray.length; i++) {
            numTotalGamesWon+=this.getNumTotalGamesWonInGamemode(gamemodesArray[i]);
        }
        return numTotalGamesWon;
    }

    getNumTotalGamesWonInGamemode(gamemode){
        var numTotalGamesWon=0;
        var booksArray=this.functions.getAllBooksPlayableInAllGamemodes();

        for (let i = 0; i < booksArray.length; i++) {
            if (this.getGamemodeofBook(booksArray[i])==gamemode) {
                numTotalGamesWon+=this.getNumgameswonOfBook(booksArray[i]);  
            }      
        }
        return numTotalGamesWon;
    }

    setSettingsCurrentGamemode(settingsCurrentGamemode){
        this.userdata[0].settingsCurrentGamemode=settingsCurrentGamemode;
        this.storeUserdata();
    };

    getSettingsCurrentGamemode(){
        return this.userdata[0].settingsCurrentGamemode;
    };

    setSettingsCurrentLanguage(settingsCurrentLanguage){
        this.userdata[0].settingsCurrentLanguage=settingsCurrentLanguage;
        this.storeUserdata();
    };

    getSettingsCurrentLanguage(){
        return this.userdata[0].settingsCurrentLanguage;
    };

    setSettingsCurrentSoundEffectStatus(settingsCurrentSoundEffectStatus){
        this.userdata[0].settingsCurrentSoundEffectStatus=settingsCurrentSoundEffectStatus;
        this.storeUserdata();
    };

    getSettingsCurrentSoundEffectStatus(){
        return this.userdata[0].settingsCurrentSoundEffectStatus;
    };

    setSettingsCurrentMusicVolume(settingsCurrentMusicVolume){
        this.userdata[0].settingsCurrentMusicVolume=settingsCurrentMusicVolume;
        this.storeUserdata();
    };

    getSettingsCurrentMusicVolume(){
        return this.userdata[0].settingsCurrentMusicVolume;
    };

    setSettingsCurrentCatChosen(settingsCurrentCatChosen){
        this.userdata[0].settingsCurrentCatChosen=settingsCurrentCatChosen;
        this.storeUserdata();
    };

    getSettingsCurrentCatChosen(){
        return this.userdata[0].settingsCurrentCatChosen;
    };

    setToken(token){
        this.userdata[0].token=token;
        this.storeUserdata();
    };

    getToken(){
        return this.userdata[0].token;
    };

    setSession_name(session_name){
        this.userdata[0].session_name=session_name;
        this.storeUserdata();
    };

    getSession_name(){
        return this.userdata[0].session_name;
    };

    setSessid(sessid){
        this.userdata[0].sessid=sessid;
        this.storeUserdata();
    };

    getSessid(){
        return this.userdata[0].sessid;
    };

    /* --------- GETTER/SETTER BOOKSINFO --------- */

    getLanguageofBook(idBook){
        return this.userdata[0].booksinfo[idBook-1].language;
    };

    getGamemodeofBook(idBook){
        return this.userdata[0].booksinfo[idBook-1].gamemode;
    };

    getBookmarkLetter(){
        var idBook=this.functions.getIdCurrentBook();
        return parseInt(this.userdata[0].booksinfo[idBook-1].bookmarkLetter);
    };

    getBookmarkLetterofBook(idBook){
        return parseInt(this.userdata[0].booksinfo[idBook-1].bookmarkLetter);
    };

    getCurrentIdChunkInBook(){
        var idBook=this.functions.getIdCurrentBook();
        return parseInt(this.userdata[0].booksinfo[idBook-1].currentIdChunkInBook);
    };

    getCurrentIdChunkInBookOfBook(idBook){
        return parseInt(this.userdata[0].booksinfo[idBook-1].currentIdChunkInBook);
    };

    getCurrentIdChunkInBookForViz(){
        return this.getCurrentIdChunkInBook()+1;
    };

    getCurrentIdChunkInBookOfBookForViz(idBook){
        return this.getCurrentIdChunkInBookOfBook(idBook)+1;
    };

    getCurrentNumLettersGuessedInCurrentChunk(){
        var idBook=this.functions.getIdCurrentBook();
        return parseInt(this.userdata[0].booksinfo[idBook-1].currentNumLettersGuessedInCurrentChunk);
    };

    getCurrentNumLettersGuessedInCurrentChunkOfBook(idBook){
        return parseInt(this.userdata[0].booksinfo[idBook-1].currentNumLettersGuessedInCurrentChunk);
    };

    getNumsnttotal(){
        var idBook=this.functions.getIdCurrentBook();
        return parseInt(this.userdata[0].booksinfo[idBook-1].numsnttotal);
    };

    getNumsnttotalofBook(idBook){
        return parseInt(this.userdata[0].booksinfo[idBook-1].numsnttotal);
    };

    getCurrentTime(){
        var idBook=this.functions.getIdCurrentBook();
        return parseInt(this.userdata[0].booksinfo[idBook-1].currentTime);
    };

    getCurrentChunkScore(){
        var idBook=this.functions.getIdCurrentBook();
        return parseInt(this.userdata[0].booksinfo[idBook-1].currentChunkScore);
    };

    getNumchunktotal(){
        var idBook=this.functions.getIdCurrentBook();
        return parseInt(this.userdata[0].booksinfo[idBook-1].numchunktotal);
    };

    getNumchunktotalOfBook(idBook){
        return parseInt(this.userdata[0].booksinfo[idBook-1].numchunktotal);
    };

    getNumchunkcompleted(){
        var idBook=this.functions.getIdCurrentBook();
        return parseInt(this.userdata[0].booksinfo[idBook-1].numchunkcompleted);
    };

    getNumchunkcompletedOfBook(idBook){
        return parseInt(this.userdata[0].booksinfo[idBook-1].numchunkcompleted);
    };

    getNumchunkskippedatbeginning(){
        var idBook=this.functions.getIdCurrentBook();
        return parseInt(this.userdata[0].booksinfo[idBook-1].numchunkskippedatbeginning);
    };

    getNumchunkskippedatbeginningOfBook(idBook){
        return parseInt(this.userdata[0].booksinfo[idBook-1].numchunkskippedatbeginning);
    };

    getNumcharguessed(){
        var idBook=this.functions.getIdCurrentBook();
        return parseInt(this.userdata[0].booksinfo[idBook-1].numcharguessed);
    };

    getNumcharguessedOfBook(idBook){
        return parseInt(this.userdata[0].booksinfo[idBook-1].numcharguessed);
    };

    getNumcharskippedatbeginning(){
        var idBook=this.functions.getIdCurrentBook();
        return parseInt(this.userdata[0].booksinfo[idBook-1].numcharskippedatbeginning);
    };

    getNumcharskippedatbeginningOfBook(idBook){
        return parseInt(this.userdata[0].booksinfo[idBook-1].numcharskippedatbeginning);
    };

    getNumgamesplayed(){
        var idBook=this.functions.getIdCurrentBook();
        return parseInt(this.userdata[0].booksinfo[idBook-1].numgamesplayed);
    };

    getNumgamesplayedOfBook(idBook){
        return parseInt(this.userdata[0].booksinfo[idBook-1].numgamesplayed);
    };

    getNumgameswon(){
        var idBook=this.functions.getIdCurrentBook();
        return parseInt(this.userdata[0].booksinfo[idBook-1].numgameswon);
    };

    getNumgameswonOfBook(idBook){
        return parseInt(this.userdata[0].booksinfo[idBook-1].numgameswon);
    };

    getNumchunkRemaining(){
        return this.getNumchunkRemainingOfBook(this.functions.getIdCurrentBook());
    }

    getNumchunkRemainingOfBook(idBook){
        var gamemode=this.getGamemodeofBook(idBook);

        if (gamemode.indexOf("reverse") > -1) { // is reverse
            return this.getCurrentIdChunkInBookOfBook(idBook)+1;
        }else{
            // getNumchunktotalOfBook is 1-N and getCurrentIdChunkInBookOfBook 0-N so here it is the +1
            // +1 for the current chunk is unfinished so is out of the calculation
            return (this.getNumchunktotalOfBook(idBook)-((this.getCurrentIdChunkInBookOfBook(idBook)+1))+1);
        }
    }

    getIndexLastCharacterInBook(){
        var idBook=this.functions.getIdCurrentBook();
        return parseInt(this.userdata[0].booksinfo[idBook-1].indexlastcharacterinbook);
    };

    getIndexLastCharacterInBookOfBook(idBook){
        return parseInt(this.userdata[0].booksinfo[idBook-1].indexlastcharacterinbook);
    };

    setBookmark(bookmark){
        var idBook=this.functions.getIdCurrentBook();
        this.userdata[0].booksinfo[idBook-1].bookmark=bookmark;
        this.storeUserdata();
    };

    setBookmarkLetter(bookmarkLetter){
        var idBook=this.functions.getIdCurrentBook();
        this.userdata[0].booksinfo[idBook-1].bookmarkLetter=bookmarkLetter;
        this.storeUserdata();
    };

    setCurrentIdChunkInBook(currentIdChunkInBook){
        var idBook=this.functions.getIdCurrentBook();
        this.userdata[0].booksinfo[idBook-1].currentIdChunkInBook=currentIdChunkInBook;
        this.storeUserdata();
    };

    setCurrentNumLettersGuessedInCurrentChunk(currentNumLettersGuessedInCurrentChunk){
        var idBook=this.functions.getIdCurrentBook();
        this.userdata[0].booksinfo[idBook-1].currentNumLettersGuessedInCurrentChunk=currentNumLettersGuessedInCurrentChunk;
        this.storeUserdata();
    }
    
    setNumsnttotal(numsnttotal){
        var idBook=this.functions.getIdCurrentBook();
        this.userdata[0].booksinfo[idBook-1].numsnttotal=numsnttotal;
        this.storeUserdata();
    };
    
    setIndexLastCharacterInBook(indexlastcharacterinbook){
        var idBook=this.functions.getIdCurrentBook();
        this.userdata[0].booksinfo[idBook-1].indexlastcharacterinbook=indexlastcharacterinbook;
        this.storeUserdata();
    };

    setNumchunktotal(numchunktotal){
        var idBook=this.functions.getIdCurrentBook();
        this.userdata[0].booksinfo[idBook-1].numchunktotal=numchunktotal;
        this.storeUserdata();
    };

    setNumchunkcompleted(numchunkcompleted){
        var idBook=this.functions.getIdCurrentBook();
        this.userdata[0].booksinfo[idBook-1].numchunkcompleted=numchunkcompleted;
        this.storeUserdata();
    };

    setNumchunkskippedatbeginning(numchunkskippedatbeginning){
        var idBook=this.functions.getIdCurrentBook();
        this.userdata[0].booksinfo[idBook-1].numchunkskippedatbeginning=numchunkskippedatbeginning;
        this.storeUserdata();
    };

    setNumcharguessed(numcharguessed){
        var idBook=this.functions.getIdCurrentBook();
        this.userdata[0].booksinfo[idBook-1].numcharguessed=numcharguessed;
        this.storeUserdata();
    };

    setNumcharskippedatbeginning(numcharskippedatbeginning){
        var idBook=this.functions.getIdCurrentBook();
        this.userdata[0].booksinfo[idBook-1].numcharskippedatbeginning=numcharskippedatbeginning;
        this.storeUserdata();
    };

    setNumgamesplayed(numgamesplayed){
        var idBook=this.functions.getIdCurrentBook();
        this.userdata[0].booksinfo[idBook-1].numgamesplayed=numgamesplayed;
        this.storeUserdata();
    };

    setNumgameswon(numgameswon){
        var idBook=this.functions.getIdCurrentBook();
        this.userdata[0].booksinfo[idBook-1].numgameswon=numgameswon;
        this.storeUserdata();
    };

    setCurrentTime(currentTime){
        var idBook=this.functions.getIdCurrentBook();
        this.userdata[0].booksinfo[idBook-1].currentTime=currentTime;
        this.storeUserdata();
    };

    setCurrentChunkScore(currentChunkScore){
        var idBook=this.functions.getIdCurrentBook();
        this.userdata[0].booksinfo[idBook-1].currentChunkScore=currentChunkScore;
        this.storeUserdata();
    };

    /* --------- END --------- GETTER/SETTER --------- */
}


// WEBPACK FOOTER //
// ./src/providers/userdata-model.ts